<template lang="pug">
  main
    NavBarDucter
    ModalInfo(v-show="modalStatus" :title="titleModal" :content="contentModal" @padre:close="cerrarModal")
    section.section.is-small(v-show="!isLoading")
      .container
        .columns.has-text-dark
          .column.is-4-tablet.is-offset-4-tablet.is-4-desktop.is-offset-4-desktop.has-text-centered
            h1.is-size-3.has-text-weight-medium Registrar video en DucterTube
              | 
              a.button.is-dark.is-rounded.is-size-6.is-small(@click='goBack')
                  i.fas.fa-times
        .columns.has-text-dark
          .column.is-4-tablet.is-offset-4-tablet.is-4-desktop.is-offset-4-desktop.has-text-centered
            div.has-text-centered.column-login
              form(enctype="multipart/form-data" @submit.prevent="submitForm")
                .field
                  label.label.is-size-5 Nombre
                  .control.has-icons-left.has-icons-right
                    input.input.is-dark.is-medium(
                      type='text', 
                      placeholder='Nombre de usuario',
                      v-model="video.nombre",
                      required
                    )
                    span.icon.is-small.is-left
                      i.fas.fa-user
                .field
                  label.label.is-size-5 Email
                  .control.has-icons-left.has-icons-right
                    input.input.is-dark.is-medium(
                      type='email', 
                      placeholder='Email',
                      v-model="video.email"
                      required
                    )
                    span.icon.is-small.is-left
                      i.fas.fa-envelope
                .field
                  label.label.is-size-5 Puesto
                  .control.has-icons-left.has-icons-right
                    input.input.is-dark.is-medium(
                      type='text', 
                      placeholder='Admistración, Operador...',
                      v-model="video.puesto"
                      required
                    )
                    span.icon.is-small.is-left
                      i.fas.fa-user-tag
                .field
                  label.label.is-size-5 Centro de Trabajo
                  .control.has-icons-left.has-icons-right
                    input.input.is-dark.is-medium(
                      type='text', 
                      placeholder='TPA, Ducter, Financiera...',
                      v-model="video.centroTrabajo"
                      required
                    )
                    span.icon.is-small.is-left
                      i.fas.fa-building
                .field
                  label.file-label
                    input.file-input(
                      type="file", 
                      name="video",
                      accept="video/*"
                      @change="selectFile($event)"
                    )
                    span.file-cta
                      span.file-icon
                        i.fas.fa-upload
                      span.file-label Escoge un video
                    span.file-name {{ video.nombreArchivo }}
                .columns
                  .column.is-12
                    div.has-text-centered
                      button.button.is-fullwidth.is-black(type="submit") Subir video
    Loader(v-show="isLoading")
</template>

<script>
import Loader from '@/components/shared/Loader.vue'
import NavBarDucter from '@/components/layout/NavBarDucter.vue'
import ModalInfo from '@/components/shared/ModalInfo.vue'
import videoServices from '@/services/videos'

export default {
  name: 'Ductertube',
  components: { Loader, ModalInfo, NavBarDucter },
  data () {
    return {
      video: {
        nombre: '',
        email: '',
        archivo: null,
        puesto: '',
        centroTrabajo: '',
        nombreArchivo: '',
      },
      isLoading: false,
      modalStatus: false,
      contentModal: '',
      titleModal: '',
      modalNavBar: false,
    }
  },
  methods: {
    submitForm() {
      console.log('submit')
      videoServices.post(this.video)
        .then(response => {
          console.log(response.respuesta)
          if (response.success) {
            let toast = this.$toasted.show(`${response.respuesta}`, { 
              theme: "toasted-primary", 
              position: "bottom-right", 
              duration : 3000,
              iconPack: 'fontawesome',
              icon: 'done',
              action : {
                text : 'Ok',
                onClick : (e, toastObject) => {
                  toastObject.goAway(0)
                }
              },
            })
            setTimeout(() => {
              this.$router.push('/')
            }, 3000)
            
          } else {
            let toast = this.$toasted.show(`${response.respuesta}`, { 
              theme: "bubble",
              position: "bottom-right",
              duration : 3000,
              iconPack: 'fontawesome',
              icon: 'ban',
              action : {
                text : 'Ok',
                onClick : (e, toastObject) => {
                  toastObject.goAway(0)
                }
              },
            })
          }
        })
        .catch(e => {
          console.log(e.message)
        })
    },
    cerrarModal () {
      this.modalStatus = false
    },

    selectFile(event) {
      if (event.target.files.length > 0) {
        console.log(event.target.files)
        this.video.archivo = event.target.files[0]
        this.video.nombreArchivo = event.target.files[0].name
      }
    },
    goBack () {
      this.$router.back()
    }
  }
}
</script>


<style lang="css" scoped>
  #logoDucter {
    max-width: 300px;
    height: auto;
  }
  .image {
    display: inline-block;
  }
  #logo {
    margin-bottom: 30px;
  }

  @media (min-width:641px) and (orientation: portrait) {
    .column-login {
      width: 30vh;
      margin-left: 20vh;
    }
  }
  
</style>


// WEBPACK FOOTER //
// src/components/ducterTube/views/nuevo.vue